import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { DataLake } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import RetrievalHelp from "data-lake/RetrievalHelp";
import DataLakeRetrievalActionForm from "data-lake/components/DataLakeActionModals/DataLakeRetrievalActionForm";
import { toInternalTime } from "data-lake/logic/Utils";
import useUserDateTime from "hooks/useUserDateTime";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const onRetrieveInternalMessages = ({ data_lake_id, stream_ids, inclusion_type, field_filters, operator }, from, to) => {
  const request = {
    type: INTERNAL_DATA_LAKE_TYPE,
    data_lake_id,
    stream_ids,
    inclusion_type,
    field_filters,
    operator
  };
  return DataLake.retrieveBulkRetrievalRequest(request, from, to);
};
const RetrievalArchiveModal = ({
  archiveStreamId = void 0,
  calculateEstimatedSize = void 0,
  onToggleModal,
  defaultFieldFilters = void 0,
  defaultFieldOperator = void 0,
  defaultTimeRange = void 0,
  onRetrieveMessages = onRetrieveInternalMessages
}) => {
  const { t } = useTranslation("enterprise_data_lake");
  const { selectedDataLake } = useSelectedDataLake();
  const queryClient = useQueryClient();
  const { userTimezone } = useUserDateTime();
  const dataLakeLabel = selectedDataLake.title ? t("retrieval_archive_modal.label_with_title", { title: selectedDataLake.title }) : t("retrieval_archive_modal.label_selected");
  const onRestoreSubmit = useCallback(
    (values) => {
      const internalFrom = values.from ? toInternalTime(values.from, userTimezone) : "";
      const internalTo = values.to ? toInternalTime(values.to, userTimezone) : "";
      onRetrieveMessages(values, internalFrom, internalTo).then(() => {
        UserNotification.success(
          t("retrieval_archive_modal.success_notification"),
          t("retrieval_archive_modal.success_title")
        );
      }).catch((error) => {
        UserNotification.error(t("retrieval_archive_modal.error_notification", { error: `${error}` }));
      }).finally(() => {
        queryClient.invalidateQueries({
          queryKey: ["data-lake"]
        });
        onToggleModal();
      });
    },
    [onRetrieveMessages, onToggleModal, queryClient, userTimezone, t]
  );
  return /* @__PURE__ */ React.createElement(
    DataLakeRetrievalActionForm,
    {
      calculateEstimatedSize,
      modalTitle: t("retrieval_archive_modal.modal_title"),
      show: true,
      onHide: onToggleModal,
      submitButtonText: t("retrieval_archive_modal.submit_button"),
      dataLakeId: selectedDataLake.id,
      streamIds: [archiveStreamId],
      onSubmit: onRestoreSubmit,
      defaultTimeRange,
      defaultFieldOperator,
      defaultFieldFilters
    },
    /* @__PURE__ */ React.createElement("p", null, t("retrieval_archive_modal.confirm", { dataLakeLabel })),
    /* @__PURE__ */ React.createElement(RetrievalHelp, null)
  );
};
export default RetrievalArchiveModal;
